const recipeModal = document.querySelector('.recipe-modal, .filter-modal');

if (recipeModal) {
  // Default statusbar color
  const getDefaultColor = () => {
    const metaTheme = document.querySelector('meta[name="theme-color"]');
    return metaTheme?.content || '#ffffff';
  };

  // Set statusbar color
  const setStatusBarColor = (color) => {
    let metaTheme = document.querySelector('meta[name="theme-color"]');
    if (!metaTheme) {
      metaTheme = document.createElement('meta');
      metaTheme.name = 'theme-color';
      document.head.appendChild(metaTheme);
    }
    metaTheme.content = color;
  };

  const defaultColor = getDefaultColor();
  const modalBackground = '#000000';

  // Close modal
  attachEvent('[data-close-modal], [data-close-filter-modal]', 'click', (ev) => {
    toggleModal(ev.target, false);
    const iosTopBar = document.querySelector('.ios-status-overlay');
    if (!iosTopBar) return;
    iosTopBar.classList.add('is-active');
    setTimeout(() => {
      iosTopBar.classList.remove('is-active');
    }, 300);
    setStatusBarColor(defaultColor);
  });

  // Open modal
  attachEvent('[data-recipe-modal-trigger]', 'click', (ev) => {
    ev.preventDefault();
    toggleModal(ev.target, true);
    setStatusBarColor(modalBackground);
  });

  // Toggle Drawer
  const toggleDrawer = (element, toggle) => {
    const parentElement = element.closest('[data-drawer-parent]');
    const drawer = parentElement?.querySelector('[data-drawer]');
    drawer?.classList.toggle('is-open', toggle);
  };

  attachEvent('[data-recipe-drawer-trigger]', 'click', (ev) => {
    ev.preventDefault();
    toggleDrawer(ev.target, true);
  });

  attachEvent('[data-close-drawer]', 'click', (ev) => {
    toggleDrawer(ev.target, false);
  });
}
